
//export var IsiCpFns: (() => void)[] = [];
export var IsiComponentsTranslations;
export var IsiTranslations;
declare function isiPostBack(eventTarget: string, eventArgument: any);

export var Responsive = {
    Mode: {
        Desktop: 'Desktop',
        Tablet: 'Tablet',
        Mobile: 'Mobile'
    }
};

/**
 * GBAU - 12/10/2012 - DYSF51947 : Permet de générer un GUID
 * */
export function generateGuid(): string {
    let result = '';
    let j: number;

    for (j = 0; j < 32; j++) {
        if (j === 8 || j === 12 || j === 16 || j === 20) {
            result = result + '-';
        }
        result = result + Math.floor(Math.random() * 16).toString(16).toUpperCase();
    }
    return result
}

window.generateGuid = generateGuid;


export function objectIsEmpty(ob: Object) {
    return jQuery.isEmptyObject(ob);
}

window.objectIsEmpty = objectIsEmpty;

export function addParamToUrl(url, param, value) {
    var a = document.createElement('a');
    a.href = url;
    a.search += a.search.substring(0, 1) == "?" ? "&" : "?";
    a.search += encodeURIComponent(param);
    if (value)
        a.search += "=" + encodeURIComponent(value);
    return a.href;
}

window.addParamToUrl = addParamToUrl;

export function replaceParamToUrl(url, param, value) {
    if (value == null)
        value = '';
    var pattern = new RegExp('\\b(' + param + '=).*?(&|$)')
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + value + '$2');
    }
    return url + (url.indexOf('?') > 0 ? '&' : '?') + param + '=' + value
}

export function addOrReplaceParamToUrl(url, param, value) {
    if (url.indexOf(param) === false) {
        return addParamToUrl(url, param, value);
    } else {
        return replaceParamToUrl(url, param, value);
    }
}

window.addOrReplaceParamToUrl = addOrReplaceParamToUrl;

export function getUrlVar() {
    var result = {};
    var location = window.location.href.split('#');
    var parts = location[0].replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        result[key] = value;
        return value;
    });
    return result;
}

export function doPostBackAsync(eventName, eventArgs, callback) {
    var prm = window.Sys.WebForms.PageRequestManager.getInstance();

    if (callback) {
        prm.add_endRequest(callback);
    }

    if (!Array.contains(prm._asyncPostBackControlIDs, eventName)) {
        prm._asyncPostBackControlIDs.push(eventName);
    }

    if (!Array.contains(prm._asyncPostBackControlClientIDs, eventName)) {
        prm._asyncPostBackControlClientIDs.push(eventName);
    }
    //console.log("AsyncPostBack = " + eventArgs);
    isiPostBack(eventName, eventArgs);
}

export var IsiJsTools = {
    concatUrl: function (base, path) {
        if (!base.endsWith("/") && !path.startsWith("/")) {
            return base + "/" + path;
        } else {
            return base + path;
        }
    }
}

window.IsiJsTools = IsiJsTools;

export function updateDtoProperty(dto, property, value) {
    if (value == "True" || value == "true" || value == "False" || value == "false") {
        value = JSON.parse(value.toLowerCase());
    }
    dto[uncapitalize(property)] = value;
}
window.updateDtoProperty = updateDtoProperty;

export function capitalize(s) {
    if (s != null) {
        return s.substr(0, 1).toUpperCase() + s.substr(1);
    }
    return null;
}
window.capitalize = capitalize;

export function uncapitalize(s) {
    if (s != null) {
        return s.substr(0, 1).toLowerCase() + s.substr(1);
    }
    return null;
}
window.uncapitalize = uncapitalize;

export function stopPropagation(oEvent) {
    //GBAU - 21/09/2012 - DYSF52264
    /// <summary>
    ///  Stop la propagation de l'evenement donne.
    /// </summary>
    /// <param name="e" type="event">evenement a stopper.</param>
    if (oEvent) {
        if (oEvent.stopPropagation) oEvent.stopPropagation();
        else oEvent.cancelBubble = true;
        if (oEvent.stopImmediatePropagation) oEvent.stopImmediatePropagation();
    }
}

window.stopPropagation = stopPropagation;

export var IEversion = null;
export var IEMobile = null;
export var Edge = null;
export var EdgeMobile = null;
export var Firefox = null;
export var FirefoxMobile = null;
export var Chrome = null;
export var ChromeMobile = null;
export var Opera = null;
export var Safari = null;
export var SafariMobile = null;
export var iPhone = null;
export var iPad = null;
export var _IsiBrowser = null;
export var IOs = null;
export var Android = null;


// detect IE
IEversion = detectIE();
// detect IE Mobile
IEMobile = detectIEMobile();

if (IEversion === false) {
    // detect Edge
    Edge = detectEdge();
    // detect Edge Mobile
    EdgeMobile = detectEdgeMobile();

    if (Edge === false) {
        // detect Firefox
        Firefox = detectFirefox();
        // detect Firefox Mobile
        FirefoxMobile = detectFirefoxMobile();

        if (Firefox === false) {
            // detect Chrome
            Chrome = detectChrome();
            // detect Chrome Mobile
            ChromeMobile = detectChromeMobile();

            if (Chrome === false) {
                // Detect Safari
                Safari = detectSafari();
                // Detect Safari Mobile
                SafariMobile = detectSafariMobile();

                if (Safari === false) {
                    // Detect Opera
                    Opera = detectOpera();
                } else {
                    // => Safari
                    Opera = false;
                }
            } else {
                // => Chrome
                Safari = false;
                SafariMobile = false;
                Opera = false;
            }
        } else {
            // => Firefox
            Chrome = false;
            ChromeMobile = false;
            Safari = false;
            SafariMobile = false;
            Opera = false;
        }

        // => Chrome / Safari / Opera / autres

        // Detect iPhone
        iPhone = detectiPhone();
        iPad = detectiPad();

        // détection de l'OS
        IOs = detectiOs();
        if (!IOs) {
            Android = detectAndroid();
        }
    } else {
        // => Edge
        Firefox = false;
        FirefoxMobile = false;
        Chrome = false;
        ChromeMobile = false;
        Safari = false;
        SafariMobile = false;
        Opera = false;

        iPhone = false;
        iPad = false;
        IOs = false;
        Android = false;
    }
} else {
    // => IE
    Edge = false;
    EdgeMobile = false;
    Firefox = false;
    FirefoxMobile = false;
    Chrome = false;
    ChromeMobile = false;
    Safari = false;
    SafariMobile = false;
    Opera = false;

    iPhone = false;
    iPad = false;
    IOs = false;
    Android = false;
}

_IsiBrowser = IEMobile || IEversion || EdgeMobile || Edge || FirefoxMobile || Firefox || ChromeMobile || Chrome || SafariMobile || Safari || Opera;

window.IEversion = IEversion;
window.IEMobile = IEMobile;
window.Edge = Edge;
window.EdgeMobile = EdgeMobile;
window.Firefox = Firefox;
window.FirefoxMobile = FirefoxMobile;
window.Chrome = Chrome;
window.ChromeMobile = ChromeMobile;
window.Opera = Opera;
window.Safari = Safari;
window.SafariMobile = SafariMobile;
window.iPhone = iPhone;
window.iPad = iPad;
window.IOs = IOs;
window.Android = Android;



/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
export function detectIE() {
    if (IEversion != null) {
        return IEversion;
    }

    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // IE 12 / Spartan => Edge beta
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299';

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge => return false
        return false;
    }

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}

export function detectIEMobile() {
    if (detectIE() !== false && navigator.userAgent.toLowerCase().indexOf('mobile') > -1) {
        return "IEMobile" + IEversion
    }
    return false;
}

/**
 * detect Edge
 * returns edge or false, if browser is not Edge
 */
export function detectEdge() {
    if (Edge != null) {
        return Edge;
    }

    var ua = window.navigator.userAgent;

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        return "edge";
    }

    // other browser
    return false;
}

/**
 * detect Edge mobile
 * returns edgeMobile or false, if browser is not Edge mobile
 */
export function detectEdgeMobile() {
    if (EdgeMobile != null) {
        return EdgeMobile;
    }

    if (detectEdge() !== false && navigator.userAgent.toLowerCase().indexOf('mobile') > -1) {
        return "edgeMobile"
    }

    return false;
}

/**
 * detect Firefox
 * returns firefox or false, if browser is not Firefox
 */
export function detectFirefox() {
    if (Firefox != null) {
        return Firefox;
    }

    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || navigator.userAgent.toLowerCase().indexOf('fxios') > -1) {
        return "firefox";
    }
    // other browser
    return false;
}

/**
 * detect Firefox mobile
 * returns firefoxMobile or false, if browser is not Firefox mobile
 */
export function detectFirefoxMobile() {
    if (FirefoxMobile != null) {
        return FirefoxMobile;
    }
    if (detectFirefox() && navigator.userAgent.toLowerCase().indexOf('android') > -1) {
        return "firefoxMobile";
    }
    // other browser
    return false;
}

/**
 * detect Chrome
 * returns chrome or false, if browser is not Chrome
 */
export function detectChrome() {
    if (Chrome != null) {
        return Chrome;
    }
    if ((navigator.userAgent.toLowerCase().indexOf('chrome/') > -1 || navigator.userAgent.toLowerCase().indexOf('crios/') > -1) && navigator.userAgent.toLowerCase().indexOf('edge/') == -1) {
        return "chrome";
    }
    // other browser
    return false;
}

/**
 * detect Chrome
 * returns chrome or false, if browser is not Chrome
 */
export function detectChromeMobile() {
    if (ChromeMobile != null) {
        return ChromeMobile;
    }
    if (detectChrome() && (/Android.*Chrome\/[.0-9]* (Mobile)?/.test(navigator.userAgent) || (/CriOS/i.test(navigator.userAgent) && /iPhone|iPad/i.test(navigator.userAgent)))) {
        return "chromeMobile";
    }
    // other browser
    return false;
}
/**
 * returns true si on est avec chrome on android
 */
export function isChromeOnAndroid() {
    const ua: string = navigator.userAgent.toLowerCase();
    return ua.includes("android") &&
        ua.includes("chrome") &&
        !ua.includes("edg") && // exclure Edge
        !ua.includes("opr");   // exclure Opera
}

/**
 * detect Opera
 * returns opera or false, if browser is not Opera
 */
export function detectOpera() {

    if (navigator.userAgent.toLowerCase().indexOf('opr/') > -1 || navigator.userAgent.toLowerCase().indexOf('opios') > -1 || navigator.userAgent.toLowerCase().indexOf('opera') > -1 || navigator.userAgent.toLowerCase().indexOf('opera mini') > -1) {
        return "opera";
    }
    // other browser
    return false;
}

/**
 * detect Safari
 * returns safari or false, if browser is not Safari
 */
export function detectSafari() {
    if (Safari != null) {
        return Safari;
    }
    if (navigator.userAgent.toLowerCase().indexOf('safari/') > -1 && navigator.userAgent.toLowerCase().indexOf('chrome/') == -1 && navigator.userAgent.toLowerCase().indexOf('edge') == -1 && navigator.userAgent.toLowerCase().indexOf('fxios') == -1 && navigator.userAgent.toLowerCase().indexOf('crios') == -1 && navigator.userAgent.toLowerCase().indexOf('opios') == -1) {
        return "safari";
    }
    // other browser
    return false;
}
/**
 * Fonction qui retourne si l'os sur lequel nous sommes est ios 
 */
export function detectiOs() {
    return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}
/**
 * Fonction qui retourne si l'os sur lequel nous sommes est Android 
 */
export function detectAndroid() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // On test la présence de Windows phone qui des fois fais comme certains users agent
    return /android/i.test(userAgent) && !/windows phone/i.test(userAgent);
}
/**
 * detect Safari
 * returns safari or false, if browser is not Safari
 */
export function detectSafariMobile() {
    if (SafariMobile != null) {
        return SafariMobile;
    }
    if (detectSafari() && (/iPad/i.test(navigator.userAgent) || /iPhone/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return "safariMobile";
    }
    // other browser
    return false;
}

/**
 * detect iPhone
 * returns iPhone or false, if device is not iPhone
 */
export function detectiPhone() {
    if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1) {
        return "iphone";
    }
    // other device
    return false;
}

/**
 * detect iPhone
 * returns iPhone or false, if device is not ipad
 */
export function detectiPad() {
    if (navigator.userAgent.toLowerCase().indexOf('ipad') > -1) {
        return "ipad";
    }
    // other device
    return false;
}

export var IsiBrowser = {
    isIE: IEversion !== false,
    isEdge: Edge !== false,
    isFirefox: Firefox !== false,
    isChrome: Chrome !== false,
    isOpera: Opera !== false,
    isSafari: Safari !== false,
    isiPhone: iPhone !== false,
    isiPad: iPad !== false
}

window.IsiBrowser = IsiBrowser;

//jQuery(document).ready(function () {
//    setTimeout(function () {
//        uiCore.detectClient();
//    }, 500);

//});
export function updateDeviceInfos(width, height, rwdMode, rwdOrientation, isMobile) {
    var jElement;

    /* jElement = jQuery("#deviceInfos");
 
     if (jElement.length == 0) {
         jElement = jQuery('<div id="deviceInfos" style="display: inline;"></div>');
         jQuery("body").append(jElement);
     }
 
     //var width;
     //var height;
     //var rwdMode;
     //var rwdOrientation;
 
     //width = jQuery(window).width();
     //height = jQuery(window).height();
     //rwdMode = "";
     //rwdOrientation = "";
 
 
 
 
     jElement.html(_IsiBrowser + " " + width + 'x' + height);
 
     //if (isiApp && isiApp.dtoClientIWS) {
     //rwdMode = isiApp.dtoClientIWS.RwdMode;
     //rwdOrientation = isiApp.dtoClientIWS.RwdOrientation;
 
     switch (rwdMode) {
         case 0:
             rwdMode = "Desktop";
             break;
 
         case 1:
             rwdMode = "Tablet";
             break;
 
         case 2:
             rwdMode = "Phone";
             break;
     }
 
     switch (rwdOrientation) {
         case 0:
             rwdOrientation = "Landscape";
             break;
 
         case 1:
             rwdOrientation = "Portrait";
             break;
     }
 
     jElement.append(" (" + rwdMode + "/" + rwdOrientation + ")");
 
     if (isMobile) {
         jElement.append(" mobile");
     }
 
     jElement.append(" (" + jQuery("body").attr("class") + ")");
     //}*/

}

export function _IsiIsPopin() {
    return jQuery("html").hasClass("popin") || jQuery("body").hasClass("glob");
}

window._IsiIsPopin = _IsiIsPopin;

// Permet de tester si le paramètre est undefined, si oui alors retourne une string vide.
export function undefinedToEmptyString(string) {
    if (typeof (string) === "undefined") {
        return "";
    } else {
        return string;
    }
}

/**
 * Récupère la classe d'une font Isilog ou fontAwesome
 * @param fileIcon
 */
export function getFontClass(fileIcon: string): string {
    let fontClass;
    if (fileIcon) {
        // On ajoute la classe de l'icone à la structure.
        if (fileIcon.split("-")[0] === "fa") {
            fontClass = "fontAwesome";
        } else if (fileIcon.split("-")[0] === "fi") {
            fontClass = "fontIsilog";
        } else {
            fontClass = "fontAwesome";
        }
    } else {
        fontClass = "fontAwesome";
    }
        return fontClass;
}

window.getFontClass = getFontClass;

